

<template>
  <div class="caseCont">
    <div class="banner-cont"></div>
    <div class="main-cont part0">
      <title-content :msgObj="titleObj0"></title-content>
      <ul class="flex-lay-row">
        <li v-for="(item, ind) in list0" :key="ind" :class="`item_${ind}`"> 
          <i></i>
          <span>____</span>
          <p>{{item}}</p>
        </li>
      </ul>
    </div>
    <div class="part1">
      <title-content :msgObj="titleObj1"></title-content>
      <ul class="main-cont flex-lay-row">
        <li v-for="(item, ind) in ~~6" :key="ind" :class="`item_${ind}`"> 
          <p></p>
        </li>
      </ul>
    </div>
    <div class="main-cont part2">
      <title-content :msgObj="titleObj2"></title-content>
      <div class="img"></div>
    </div>
  </div>
</template>
<script>
export default{
  name: 'aboutUsCont',
  data () {
    return {
      currentIndex: 0,
      titleObj0: {
        title1: '接入流程',
        title2: '快速入驻，提供完整的解决方案，助力精准高效获取用户'
      },
      titleObj1: {
        title1: '精品案例',
        title2: '众多的精美模板，提供完整的解决方案，助力精准高效获取用户'
      },
      titleObj2: {
        title1: '即速应用优势',
        title2: '5分钟立即生成小程序无需代码直接制作，零技术也可以搞定所有小程序'
      },
      list0: [
        '线上化申请入驻，快速标准的注册认证流程', '企业后台管理中心简便，高效进行智能后台管理', 
        '丰富的开发者文档、标准的视觉规范指导智能敏感开发', '规范的审核标准，快捷的只能发布上线流程'
      ]
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.caseCont{
  .banner-cont{
    background-image: url('../../assets/dawing/ia_300000014.jpg');
  }
  .part0{
    li{
      @extend .flex-lay-column;
      flex: 1;
      i{
        width: .52rem;
        height: .7rem;
        display: block;
        margin-top: .8rem;
        margin-bottom: .2rem;
      }
      p{
        width: 70%;
        margin: .2rem auto;
        text-align: center;
        line-height: .3rem;
        color: #777;
      }
    }
  }
  .part1{
    background: #f8f8f8;
    ul{
      flex-wrap: wrap;
      li{
        width: 4rem;
        padding-top: .5rem;
        p{
          width: 90%;
          height: 3.2rem;
          margin: 0 auto;
        }
      }
    }
  }
  .part2{
    .img{
      margin-top: .5rem;
      // width: 40%;
      height: 5.4rem;
      background: url('../../assets/dawing/ia_300000010.png') no-repeat center;
      background-size: contain;
    }
  }
}
@for $i from 0 to 4{
  .part0 .item_#{$i} i{
    background: url('../../assets/dawing/num_item_#{$i}.png') no-repeat center;
    background-size: contain;
  }
  .part#{$i} {
    padding: 1.3rem 0;
  }
}
@for $i from 0 to 6{
  .part1 .item_#{$i} p{
    background: url('../../assets/dawing/case_item_#{$i}.png') no-repeat center;
    background-size: cover;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DAWNING/caseShow.vue